import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  StockOrderRootParamList,
  ValidSetupRootParamList,
} from "../../../../types";
import {
  RootDrawerToggle,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { StockOrderListScreen } from "../StockOrderListScreen";
import { CreateStockOrderRootScreen } from "../CreateStockOrderRootScreen";
import { EditStockOrderRootScreen } from "../EditStockOrderRootScreen";
import { ViewStockOrderRootScreen } from "../ViewStockOrderRootScreen";
import { StockOrderFilterRootScreen } from "../StockOrderFilterRootScreen";
import { StockOrderFilterValues } from "../../types";
import { useListFilter } from "../../../../utilities/list-filter";
import { ListFilterProvider } from "../../../../utilities/list-filter/use-list-filter-context";

export type StockOrderRootScreenProps = StackScreenProps<
  ValidSetupRootParamList,
  "StockOrderRootScreen"
>;

export const StockOrderRootScreen = ({}: StockOrderRootScreenProps) => {
  const Drawer = createStackHeaderNavigator<StockOrderRootParamList>();

  const filterContext = useListFilter<StockOrderFilterValues>({
    defaultValues: {
      productId: [],
      locationId: [],
    },
  });

  return (
    <ListFilterProvider {...filterContext}>
      <Drawer.Navigator
        screenOptions={{
          animationEnabled: true,
          headerLeft: () => <RootDrawerToggle />,
          title: "",
        }}
      >
        <Drawer.Group>
          <Drawer.Screen
            name="StockOrderListScreen"
            component={StockOrderListScreen}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            headerShown: false,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Drawer.Screen
            name="CreateStockOrderRootScreen"
            component={CreateStockOrderRootScreen}
          />
          <Drawer.Screen
            name="EditStockOrderRootScreen"
            component={EditStockOrderRootScreen}
          />
          <Drawer.Screen
            name="ViewStockOrderRootScreen"
            component={ViewStockOrderRootScreen}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            headerShown: false,
            presentation: "modal",
          }}
        >
          <Drawer.Screen
            name="StockOrderFilterRootScreen"
            component={StockOrderFilterRootScreen}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </ListFilterProvider>
  );
};
